import { ShiftManagementDeleteUnassignedShiftDocument } from 'generated/resources/graphql'

import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { trackDeleteUnassignedShiftSubmit } from 'modules/shift_management/lib/trackEvents'
import type { UnassignedShift } from 'modules/shift_management/lib/types'
import { removeUnassignedShiftsCoverageCache } from 'modules/shift_management/utils/apolloCache/unassignedShiftsCoverage'

const trackSubmitEvent = (unassignedShift: UnassignedShift) => {
  const shiftType = unassignedShift.isDefault ? 'defaultShift' : 'customShift'
  const counter = Number(unassignedShift.counter)

  trackDeleteUnassignedShiftSubmit(unassignedShift, shiftType, counter, 'contextual_button')
}

const useDestroyUnassignedShift = (unassignedShift: UnassignedShift) => {
  const [deleteUnassignedShift, { loading }] = useMutation(
    ShiftManagementDeleteUnassignedShiftDocument,
    {
      extractorFn: (data) => data.shiftManagementMutations.deleteShiftmanagementUnassignedShift,
      update: (cache, { data }) => {
        const deletedShift =
          data?.shiftManagementMutations.deleteShiftmanagementUnassignedShift.unassignedShift

        removeUnassignedShiftsCoverageCache({
          cache,
          unassignedShiftIds: deletedShift ? [deletedShift.id] : [],
        })
      },
    }
  )

  const onDestroy = async (closePortal: ClosePortalFn) => {
    trackSubmitEvent(unassignedShift)

    const result = await deleteUnassignedShift({
      variables: { id: unassignedShift.id },
    })

    const handled = handleResult(result, (_errors) => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('shift_management.actions.delete_unassigned_shifts_success'),
      })

      closePortal()
    }
  }

  return {
    onDestroy,
    submitting: loading,
  }
}

export { useDestroyUnassignedShift }
